import { join } from './join';

const typePlurals = {
  'House': 'houses',
  'Apartment': 'apartments',
  'Vacant Land Residential': 'lands',
  'Townhouse': 'townhouses',
  'Cluster': 'clusters',
  'Penthouse': 'penthouses',
  'Retirement Village': 'villages',
  'Garden Cottage': 'cottages',
  'Cottage': 'cottages',

  'Farm': 'farms',
  'Vacant Land Agricultural': 'lands',
  'Small holding': 'holdings',
  'Small Holding': 'holdings',
  'Agricultural Holding': 'holdings',

  'Industrial': 'industrials',
  'Office': 'offices',
  'Retail': 'retails',
  'Commercial land': 'lands',
  'Business': 'businesses',
  'Guest house': 'guest houses',
  'Game Farm': 'farms',
  'Lodge': 'lodges',

  'Residential': 'residential properties',
  'Commercial': 'commercial properties',
  'Agricultural': 'agricultural properties',
};

function getTypeNamePlural(typeName) {
  return typePlurals[typeName] || typeName.toLowerCase();
}

export function formatTypes(types) {
  if (!types?.length) return `properties`;

  return join(types.map((x) => getTypeNamePlural(x.name)));
}
